export default "__VITE_ASSET__Dg6gpVQ4__"